import { createStore, applyMiddleware, DeepPartial, } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools, } from 'redux-devtools-extension';
import {
  AppState,
  ExpertReviewAndRating,
  ConsumerReviewAndRating,
  Vehicle,
  VehicleAward,
  AccountInfoData,
} from '../types/AppState';
import rootReducer from '../reducers';
import baseState from './AppState';
import omnitureTaggingMiddleware from '../middlewares/tagging/middleware';

export interface InitialData {
  config: Record<string, any>;
  theme: Record<string, any>;
  rraData?: {
    expertReviewAndRating: ExpertReviewAndRating;
    consumerReviewAndRating: ConsumerReviewAndRating;
    vehicle: Vehicle;
    vehicleAward: VehicleAward;
    accountInfoData: AccountInfoData;
    errors?: [];
  };
}

export default function configureStore({
  config,
  theme,
  rraData,
}: InitialData) {
  const expertReviewAndRating = rraData ? rraData.expertReviewAndRating : {};
  const consumerReviewAndRating = rraData ? rraData.consumerReviewAndRating : {};
  const vehicle = rraData ? rraData.vehicle : {};
  const vehicleAward = rraData ? rraData.vehicleAward : {};
  const accountInfoData = rraData ? rraData.accountInfoData : {};
  const errors = rraData ? rraData.errors : {};

  const preloadedState: DeepPartial<AppState> = {
    ...baseState,
    app: {
      config,
      theme,
    },
    vehicle: {
      ...baseState.vehicle,
      ...vehicle,
    },
    vehicleAward: {
      ...baseState.vehicleAward,
      ...vehicleAward,
    },
    expertReviewAndRating: {
      ...baseState.expertReviewAndRating,
      ...expertReviewAndRating,
    },
    consumerReviewAndRating: {
      ...baseState.consumerReviewAndRating,
      ...consumerReviewAndRating,
    },
    accountInfoData: {
      ...baseState.accountInfoData,
      ...accountInfoData,
    },
    errors: {
      ...errors,
    },
  };
  const enhancer = (process.env.NODE_ENV === 'development')
    ? composeWithDevTools(applyMiddleware(thunk, omnitureTaggingMiddleware))
    : applyMiddleware(thunk, omnitureTaggingMiddleware);

  return createStore(
    rootReducer,
    preloadedState,
    enhancer,
  );
}
